import React, { forwardRef, useImperativeHandle, useState } from "react";
import { CommonModal } from "../../Modal";

const PositionManageModals = forwardRef(({ payloadData }, ref) => {
  const [isShow, setIsShow] = useState({
    isOpen: false,
    isEdit: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });

  // Expose to the parent component
  useImperativeHandle(ref, () => ({
    setIsShow: (data) => setIsShow((prev) => ({ ...prev, ...data })),
  }));

  return (
    <>
      <CommonModal
        isShow={isShow.isOpen}
        handleShowHide={() =>
          setIsShow((prev) => ({
            ...prev,
            isOpen: false,
            rowData: {},
            name: "",
          }))
        }
        modalTitle={isShow.modalTitle}
      >
        {isShow.modalContent &&
          React.createElement(isShow.modalContent, {
            handleShowHide: () =>
              setIsShow((prev) => ({
                ...prev,
                isOpen: false,
                rowData: {},
                name: "",
                modalTitle: "",
                apiFlag: !prev.apiFlag,
              })),
            rowData: isShow.rowData,
            payloadData: payloadData,
          })}
      </CommonModal>
    </>
  );
});

export default PositionManageModals;
